<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div>
        <strong style="position: relative; left: 80%; color: #28a745; font-size: 12px"> Total planes: {{planes.length}}</strong>
      </div>

    <strong style="color: #28a745;">Planes Asociados al tratamiento</strong>
    <b-row class="mt-2" style="display: flex;align-items:center ;justify-content: center;" v-if="cargandoLista">
      <b-spinner variant="success" />
    </b-row>
    <b-row class="mt-2">
      <b-col  sm="12" md="6" lg="6"  xl="6" >
        <b-form-checkbox-group stacked style="overflow: auto;  max-height: 250px"  v-model="selected">
          <template v-for="(d,i) in planes1">
              <div class="row ml-1" :key="d+i"  :value="d.idPlanTratamiento">
                <label>{{ d.nombrePlan }} </label>
              </div>
          </template>
        </b-form-checkbox-group>
      </b-col>
      <b-col  sm="12" md="6" lg="6"  xl="6" >
        <b-form-checkbox-group stacked style="overflow: auto; max-height: 250px" v-model="selected" @input="marcarPlan()">
          <template v-for="(d,i) in planes2">
              <div class="row ml-1" :key="d+i"  :value="d.idPlanTratamiento">
                <label >  {{ d.nombrePlan }} </label>
              </div>
          </template>
        </b-form-checkbox-group>
      </b-col>
    </b-row>

    <b-row class="mt-2" style="display: flex;align-items:end ;justify-content: end;">
      <b-button size="sm" variant="success" @click="guardarPlanes()" style="margin-right: 5px" :disabled="guardando">
        <span>Guardar</span>
        <b-spinner v-if="guardando" variant="primary" small/>
      </b-button>
      <b-button size="sm" variant="danger" @click="$bvModal.hide('my-modal')" style="margin-right: 5px" :disabled="guardando">
        Cancelar
      </b-button>
    </b-row>


  </div>
</template>

<script>
import miniToastr from "mini-toastr";

export default {
  name: "PlanesTratamiento",
  props: {
    tratamientoInactivar: Object
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    planes1: null,
    planes2: null,
    planes: null,
    selected: [],
    idsSeleccionados: null,
    cargandoLista: true,
    guardando: false
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerListaPlanes();
  },
  methods: {
    guardarPlanes(){

      this.$swal.fire({
        icon: "info",
        text: "¿Está seguro de quitar el tratamiento de la lista de planes?",
        showCancelButton: true,
        showConfirmButton: true,
        allowOutsideClick: false,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Si, de acuerdo",
        confirmButtonColor: "#0e6ba9",
      }).then((result) => {
        if (result.isConfirmed){

          this.guardando = true;
          const filtro = {
            idsPlanTratamiento: this.selected,
            idTratamiento: this.tratamientoInactivar.idTratamiento
          }
          this.$http.post(this.$api + 'tratamientos/inactivar/planes-tratamiento', filtro).then(respuesta => {
            if (respuesta.data.data) {
              this.guardando = false;

              this.$swal({
                icon: "success",
                title: "Se actualizó correctamente",
                showConfirmButton: true,
                timer: 2500,
              }).then(() => {
                this.$bvModal.hide("my-modal");
                this.$emit("registroInactivo", this.tratamientoInactivar.idTratamiento );
              });
              var message = respuesta.data.message
                  ? respuesta.data.message
                  : "Se actualizó correctamente el registro";
              miniToastr.success(message);

            }
          }).catch(( error ) => {
            this.$bvModal.hide("my-modal");
            this.guardando = false
            var message = error.response.data.message
                ? error.response.data.message
                : "Error al actualizar el tratamiento";

            this.$swal.fire({
              icon: "warning",
              text: message,
            })
          })


        }

      })
    },

    marcarPlan(){
    },
    obtenerListaPlanes(){
      const filtro= {
        idTratamiento: this.tratamientoInactivar.idTratamiento
      }
      this.$http.post(this.$api + 'tratamientos/planes-tratamiento', filtro).then(respuesta => {
        if (respuesta.data.data) {
          this.cargandoLista = false;
          this.planes = respuesta.data.data;
          var mitad = Math.floor(this.planes.length / 2)

          this.planes1 = this.planes.slice(0, mitad);
          this.planes2 = this.planes.slice(mitad);

          this.planes.forEach(p => {
            this.selected.push(p.idPlanTratamiento)
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>